import { RootState } from '../reducers';

export const casesSelector = (state: RootState): number => state.documents.totalCases;
export const casesLoadingSelector = (state: RootState): boolean => state.documents.isLoading;
export const filerModalVisible = (state: RootState): boolean => state.documents.fileModalOpen;
